"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dolegna-del-collio": {
    "fda22bc2": [{
      "hkey": "1eb3b420",
      "slug": "dolegna-del-collio",
      "name": "Dolegna del Collio",
      "primary": true,
      "skipSearch": false
    }],
    "lonzano": [{
      "hkey": "1eb3b420",
      "slug": "dolegna-del-collio",
      "name": "Dolegna del Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5f5aa25": [{
      "hkey": "1eb3b420",
      "slug": "dolegna-del-collio",
      "name": "Dolegna del Collio",
      "primary": true,
      "skipSearch": false
    }],
    "trussio": [{
      "hkey": "1eb3b420",
      "slug": "dolegna-del-collio",
      "name": "Dolegna del Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;